const emotionalWellbeing = ["0-1", "2-3", "4-5", "6-7"];
export default emotionalWellbeing;
